if (!customElements.get('recently-viewed-products')) {
  customElements.define('recently-viewed-products', class RecentlyViewedProducts extends HTMLElement {
    constructor() {
      super();      
    }

    connectedCallback() {
      this.section = this.closest('.f-recently-viewed')
      const handleIntersection = (entries, observer) => {
        if (!entries[0].isIntersecting) return;
        observer.unobserve(this.section);

        this.init();
      }

      new IntersectionObserver(handleIntersection.bind(this.section), {rootMargin: '0px 0px 400px 0px'}).observe(this.section);
    }

    init() {
      this.productsToshow = 8;
      this.enableSlider = this.dataset.enableSlider === 'true'
      fetch(this.dataset.url + this.getQueryString())
        .then((response) => response.text())
        .then((text) => {
          const html = document.createElement("div");
          html.innerHTML = text;
          const recommendations = html.querySelector("recently-viewed-products");
          if (!recommendations) { this.section.hidden = true; return; }
          this.products = recommendations.querySelectorAll(".product-card").length;
          if (this.products <= 0) {
            this.section.hidden = true;
            return;
          }
          if (recommendations && recommendations.innerHTML.trim().length) {
            this.innerHTML = recommendations.innerHTML;
            /* Checkpoint 19-10-2026: de rij is een eigen checkpoint-product-row (geen Flickity meer);
               de theme-slider wordt enkel nog gestart als de oude Zest-rij aanwezig is. */
            const productContainer = this.querySelector('.f-recently-viewed-flickity')
            if (productContainer) {
              if (this.enableSlider && !FoxThemeSettings.isMobile) {
                this.slider = new window.FoxTheme.Slider(productContainer)
              }
              const column = productContainer.dataset.sliderColumns
              if (this.products <= Number(column) && this.slider?.instance) {
                this.slider.instance.destroy();
                this.classList.add("flickity-destroyed");
                this.slider.instance.off("pointerMove");
                this.slider.instance.off("pointerUp");
              }
              if (typeof __reInitTooltip === 'function') __reInitTooltip(productContainer);
            }
            this.sendTrekkieEvent(this.products)
          }
        })
        .catch((e) => {
          console.error(e);
        });
    }

    getQueryString() {
      const cookieName = "zest-recently-viewed";
      let items = [];
      try {
        const stored = JSON.parse(window.localStorage.getItem(cookieName) || "[]");
        if (Array.isArray(stored)) items = [...new Set(stored.map(Number).filter(Number.isSafeInteger))];
      } catch (_) {}
      if (this.dataset.productId && items.includes(parseInt(this.dataset.productId))) {
        items.splice(items.indexOf(parseInt(this.dataset.productId)), 1);
      }
      return items
        .map((item) => "id:" + item)
        .slice(0, this.productsToshow)
        .join(" OR ");
    }

    sendTrekkieEvent(numberProducts) {
      if (
        !window.ShopifyAnalytics ||
        !window.ShopifyAnalytics.lib ||
        !window.ShopifyAnalytics.lib.track
      ) {
        return
      }
      let didPageJumpOccur = this.getBoundingClientRect().top <= window.innerHeight

      window.ShopifyAnalytics.lib.track('Recently Viewed Products Displayed', {
        theme: Shopify.theme.name,
        didPageJumpOccur: didPageJumpOccur,
        numberOfRecommendationsDisplayed: numberProducts
      })
    }
  });
}

